import videoJs from 'video.js'
import 'videojs-youtube'
import * as lodash from 'lodash'

export type PlaylistItem = {
  title: string
  playlistId: string
  videos: VideoItem[]
}

export type VideoItem = {
  title: string
  videoId: string
  duration: string
}

export function initVideoPlayer(element: HTMLVideoElement, videoId: string, options?: { onReady?(): void }) {
  const url = `http://www.youtube.com/embed/${videoId}`

  const ytbControls = true

  const playerOptions = {
    autoplay: true,
    controls: !ytbControls,
    techOrder: ['youtube'],
    sources: [{ type: 'video/youtube', src: url }],
    youtube: {
      ytControls: ytbControls ? 2 : undefined,
      customVars: { rel: 0 },
    },
  }

  videoJs(element, playerOptions, options?.onReady)
}

export function findRelatedVideos(videoId: string, playlists: PlaylistItem[]) {
  const items = playlists.map((item) => {
    const realted = item.videos.find((item) => item.videoId === videoId)

    return realted ? item.videos : []
  })

  return lodash.uniqBy(lodash.flatten(items), (item) => item.videoId)
}
